module.exports = __webpack_public_path__ + "static/media/BlingV3_01.c0fa086f.png";